/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(app) {
    // (no global components currently registered)
  },
};

export default GlobalComponents;
